<template>
    <div v-loading="loading">
        <div class="form-box">
            <el-form ref="form" inline :model="queryForm" label-width="80px" style="text-align: center">
                <el-form-item>
                    <el-input v-model="queryForm.facilityName" clearable placeholder="Facility Name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="queryForm.unitNo" clearable placeholder="Unit No."></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="queryForm.paymentId" clearable placeholder="Payment ID"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-input v-model="queryForm.orderId" clearable placeholder="Order ID"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="queryForm.status" placeholder="Booking status" clearable>
                        <el-option
                                v-for="item in [
                                {value:1,label:'Pending'},
                                {value:2,label:'Waiting list'},
                                {value:3,label:'Approved'},
                                {value:4,label:'Cancelled'},
                                {value:5,label:'Rejected'},
                                {value:6,label:'History'},
                                ]"
                                :key="item.value+'k-k-a'"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                            clearable
                            v-model="queryForm.created"
                            type="daterange"
                            format="dd-MM-yyyy"
                            value-format="yyyy-MM-dd"
                            start-placeholder="Booking Date"
                            end-placeholder="Booking Date">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                            clearable
                            v-model="queryForm.refundDate"
                            type="daterange"
                            format="dd-MM-yyyy"
                            value-format="yyyy-MM-dd"
                            start-placeholder="Refund Date"
                            end-placeholder=" Refund Date">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                            clearable
                            v-model="queryForm.bookingSlot"
                            type="daterange"
                            format="dd-MM-yyyy"
                            value-format="yyyy-MM-dd"
                            start-placeholder="Slots Date"
                            end-placeholder="Slots Date">
                    </el-date-picker>
                </el-form-item>

                <el-button type="primary" @click="loadData" icon="el-icon-search" size="medium" circle></el-button>
                <el-button type="primary" @click="exportData" icon="el-icon-download" size="medium" circle></el-button>
            </el-form>
        </div>
        <strong class="sub-tips"><span style="color: #F84848">* </span>Online payment is subjected to 3% service charge</strong>
        <el-table
                fit
                stripe
                @sort-change="changeSort"
                class="data-table"
                :data="data">
            <el-table-column
                    header-align="center"
                    align="center"
                    v-for="item in [
                        {prop:'bid',label:'Order ID',wth:'160px'},
                        {prop:'bookingSlot',label:'Booked Slot',fmt:selfTimeFormat,wth:'150px',sort:'custom'},
                        {prop:'unitName',label:'Unit',wth:'80px'},
                        {prop:'userName',label:'Name',wth:'160px'},
                        {prop:'phone',label:'Hp Number',wth:'140px'},
                        {prop:'facilityName',label:'Facility Name',wth:'140px'},
                        {prop:'status',label:'Status',wth:'140px',fmt:orderStatusFmt},
                        {prop:'created',label:'Booking Date',fmt:selfTimeFormat,wth:'150px'},
                        {prop:'approval',label:'Approval Date',fmt:selfTimeFormat,wth:'150px'},
                        {prop:'rejectionDate',label:'Rejection Date',wth:'140px',fmt:selfTimeFormat},
                        {prop:'reason',label:'Reason for Rejection',wth:'170px'},
                        {prop:'eazableCode',label:'QR code',wth:'150px'},
                        {prop:'paymentBid',label:'Payment ID',wth:'150px'},
                        {prop:'payStatus',label:'Status of Payment',fmt:payStatusFormat,wth:'150px'},
                        {prop:'payMethod',label:'Payment Method',fmt:paymentMethodFormat,wth:'140px'},
                        {prop:'quantity',label:'Quantity',wth:'80px'},
                        {prop:'amount',label:'Amount',wth:'100px'},
                        {prop:'payedDate',label:'Paid Date',fmt:selfTimeFormat,wth:'140px'},
                        {prop:'refundable',label:'Refundable Amount',wth:'160px'},
                        {prop:'refundedTime',label:'Refund Time',fmt:selfTimeFormat,wth:'140px'},
                        {prop:'refundStatus',label:'Refund Status',fmt:refundStatusFmt,wth:'130px'},
                        {prop:'settlement',label:'Settlement Status',fmt:settlementStatusFormat,wth:'140px'},
                    ]"
                    :formatter="item.fmt"
                    :sortable="item.sort"
                    :width="item.wth"
                    :prop="item.prop"
                    :label="item.label"
                    :key="item.label">
            </el-table-column>

            <el-table-column
                    width="150px"
                    header-align="center"
                    align="center"
                    label="Action">
                <template slot-scope="s">
                    <el-button type="warning" size="small" v-if="s.row.refundStatus === 1" @click="noRefund(s.row.id)">
                        Disable Refund
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="page">
            <el-pagination @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {facilityOrders, facilityOrderNoRefund, exportFacilityOrders} from '@/api/Facitliy'
    import {excelRequestRequest} from "@/utils/ApiUtils";

    export default {
        name: "FacilityBookingOrders",
        data: function () {
            return {
                queryForm: {},
                loading: false,
                data: [],
                page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0}
            }
        },
        methods: {
            loadData() {
                this.$pageUtils(this, facilityOrders)
            },
            changeSort(e) {
                this.queryForm.sort = e.order
                this.queryForm.sortBy = e.prop
                this.loadData()
            },
            orderStatusFmt(row, cell, val) {
                return {
                    1: "Pending",
                    2: "Waiting list",
                    3: "Approved",
                    4: "Cancelled",
                    5: "Rejected",
                    6: "History",
                }[val]
            },
            noRefund(id) {
                if (confirm('Confirm not refund the deposit to the user')) {
                    facilityOrderNoRefund(id).then(() => this.loadData())
                }
            },
            exportData() {
                excelRequestRequest(this, exportFacilityOrders);
            },
            refundStatusFmt(row, cell, val) {
                const status = {
                    1: 'Pending',
                    2: 'Refunded',
                    3: 'N/A',
                    4: 'Offline',
                    5: 'Failed',
                }
                return status[val]
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped>
    .sub-tips {
        margin-top: 4px;
        margin-bottom: 4px;
        color: #666666;
    }
</style>
